import React, { useState } from "react";
import { Card, CardMedia, CardContent, Typography, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ShoppingCart as ShoppingCartIcon } from "react-feather";
import Image from "components/Image";

const useStyles = makeStyles({
  card: {
    borderRadius: 15,
    width: "100%",
    minHeight: "25em",
    display: "flex",
    flexDirection: "column",
    transition: "transform 0.3s ease-in-out",
    "&:hover": {
      transform: "scale(1.05)",
      boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.3)",
    },
  },
  media: {
    height: "50%",
  },
  content: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  button: {
    color: "#fff",
    width: "100%",
    backgroundColor: "rgb(134, 61, 134)",
    borderRadius: "12px",
    padding: "10px 16px",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    transition: "all 0.3s ease-in-out",
    "&:hover": {
      backgroundColor: "rgb(158, 97, 170)",
    },
  },
});

function ProductCard({
  codNombre = "Código - nombre producto",
  precio = "$0",
  descripcion = "Descripción producto",
  submit = () => { },
  imageUrl,
}) {
  const styles = useStyles();
  const [hover, setHover] = useState(false); // Estado para controlar el hover

  return (
    <Card className={styles.card}>
      {imageUrl
        ? <Image className={styles.media} url={imageUrl} />
        : <CardMedia className={styles.media} image="https://picsum.photos/200/300" alt="Producto imagen" />
      }
      <CardContent className={styles.content}>
        <Typography variant="h5">{codNombre}</Typography>
        <Typography variant="h6">{precio}</Typography>
        <Typography variant="body2" color="textSecondary">
          {descripcion}
        </Typography>
        <Button
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          onClick={submit}
          className={styles.button}
        >
          {hover ? <ShoppingCartIcon size={18} /> : "Agregar al carrito"}
        </Button>
      </CardContent>
    </Card>
  );
}

export default ProductCard;
